export default __webpack_public_path__ + "static/media/instagram-fill.c70ac786.svg";